const userData = [
    {
        id: 1,
        name: "Adarsh kumar",
        college: "National institute of technology Karnataka",
        link: "adarsh-sreyan",
        description: "First thing it give me confidence to clear my interview. Before joining this I know the things which is asked in interview but I don't know how to explain the things after joining this I give a session after that  they pick my error in how I give interview like first approach Brut Force approach then optimize approach and pick standard words for explaining the things like if we want to use count of a number then use word hashing etc. After giving all these mock interview I understand my mistake and work on it and I finally placed in Amdocs. Thank you 😊",
        offers: [
            "Amdocs"
        ]
    },
    {
        id: 2,
        name: "Rahul Kauraiya",
        college: "National institute of technology Karnataka",
        link: "reclone-rk",
        description: "To achieve anything two things are important other than hardwork. One is confidence and Guidance. This platform helped me a lot in getting both the things. Their constant support and guidance made me to clear the Target. And because of the guidance I got a lot of confidence inside me. My suggestion is go for it.  It will help you a lot.",
        offers: [
            "Target Corporation"
        ]
    },
    {
        id: 3,
        name: "Rupesh Nitnaware",
        college: "National institute of technology Karnataka",
        link: "imgr00t",
        description: "I became more confindent in Interview. It also helps me to improve my problem solving skills we had an in depth discussion on my projects and resume, which gave me an idea of the kind of questions which can be asked in a real interview. The post interview feedback was very insightful as I was given tips on how I can improve both my technical as well as communication skills. ",
        offers: [
            "Make My Trip"
        ]
    },
];

export default userData;